import UAParser from 'ua-parser-js';

export type BrowserSpecs = {
  colours: string;
  resolution: string;
  window_size: string;
  browser: string;
  os: string;
  user_agent: string;
};

export default (): BrowserSpecs => {
  const parser = new UAParser(navigator.userAgent);

  return {
    colours: screen.colorDepth + ' bit',
    resolution: screen.width + ' x ' + screen.height + ' px',
    window_size: window.innerWidth + ' x ' + window.innerHeight + ' px',
    browser: parser.getBrowser().name + ' ' + parser.getBrowser().version,
    os: parser.getOS().name + ' ' + parser.getOS().version,
    user_agent: navigator.userAgent
  };
};
